import React from 'react';
export function Marquee() {
  const words = ['Caramelized', 'Custard-Soft', 'Small-Batch', 'Hand-Crafted', 'Magnolia · Texas', 'Edition Nº 01', 'Limited Release', 'Reserved by Invitation'];
  const loop = [...words, ...words];
  return <section aria-hidden className="bg-texture-espresso text-cream border-y border-cream/10 py-8 overflow-hidden" data-id="element-167">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-168">
        {loop.map((w, i) => <div key={i} className="flex items-center px-10 shrink-0" data-id="element-169">
            <span className="font-serif italic text-3xl lg:text-4xl text-cream/85 font-light" data-id="element-170">
              {w}
            </span>
            <span className="mx-10 w-1.5 h-1.5 rounded-full bg-caramel shrink-0" data-id="element-171" />
          </div>)}
      </div>
    </section>;
}